var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.638,
    height: 13.999,
    viewBox: "0 0 11.638 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(-15.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9437",
    "data-name": "Path 9437",
    d: "M26.944,13.178h-.3V.41A.41.41,0,0,0,26.23,0H16.84a.41.41,0,0,0-.41.41V13.178h-.3a.41.41,0,0,0,0,.82H26.944a.41.41,0,1,0,0-.82Zm-6.807,0v-2.8h2.8v2.8Zm3.616,0V9.972a.41.41,0,0,0-.41-.41H19.727a.41.41,0,0,0-.41.41v3.206H17.25V.82H25.82V13.178Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9438",
    "data-name": "Path 9438",
    d: "M137.66,66.309h-2.01a.41.41,0,0,0-.41.41v2.01a.41.41,0,0,0,.41.41h2.01a.41.41,0,0,0,.41-.41v-2.01A.41.41,0,0,0,137.66,66.309Zm-.41,2.01h-1.19v-1.19h1.19Z",
    transform: "translate(-117.007 -64.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9439",
    "data-name": "Path 9439",
    d: "M275.672,66.309h-2.01a.41.41,0,0,0-.41.41v2.01a.41.41,0,0,0,.41.41h2.01a.41.41,0,0,0,.41-.41v-2.01A.41.41,0,0,0,275.672,66.309Zm-.41,2.01h-1.19v-1.19h1.19Z",
    transform: "translate(-251.245 -64.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9440",
    "data-name": "Path 9440",
    d: "M137.66,205.954h-2.01a.41.41,0,0,0-.41.41v2.01a.41.41,0,0,0,.41.41h2.01a.41.41,0,0,0,.41-.41v-2.01A.41.41,0,0,0,137.66,205.954Zm-.41,2.01h-1.19v-1.19h1.19Z",
    transform: "translate(-117.007 -200.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9441",
    "data-name": "Path 9441",
    d: "M275.672,205.954h-2.01a.41.41,0,0,0-.41.41v2.01a.41.41,0,0,0,.41.41h2.01a.41.41,0,0,0,.41-.41v-2.01A.41.41,0,0,0,275.672,205.954Zm-.41,2.01h-1.19v-1.19h1.19Z",
    transform: "translate(-251.245 -200.323)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIconWhite);
export default __webpack_public_path__ + "static/media/building-icon-white.34a0d21478472a270229ae4d8cb365ce.svg";
export { ForwardRef as ReactComponent };